var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"xs-footer",attrs:{"id":"xs_footer"}},[_c('div',{staticClass:"footer-inner"},[_c('p',{staticClass:"copyright"},[_vm._v("ⓒ XGAMES all rights reserved")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }